import React from 'react';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { string, arrayOf, object } from 'prop-types';
import ListingItem from 'components/filtered-listing/items/ListingItem';

export default function TileContainer({ items, columnClass, tileWrap, tileType }) {
    return (
        <div className={`fl-tile-container ${columnClass} ${tileWrap} ${tileType}`}>
            <TransitionGroup component="div" className="row">
                {items.map((item, index) => (
                    <CSSTransition
                        // @NOTE - ideally the key should be item.guid but this creates a jumpy effect with React transition group, so we will
                        //         keep using index for now until we find a better solution
                        /* eslint-disable-next-line react/no-array-index-key */
                        key={index}
                        timeout={200}
                        classNames="fade-in-out"
                        appear={true}
                    >
                        <ListingItem
                            item={item}
                            tileType={tileType}
                        />
                    </CSSTransition>
                ))}
            </TransitionGroup>
        </div>
    );
}

TileContainer.propTypes = {
    items: arrayOf(object).isRequired,
    columnClass: string.isRequired,
    tileType: string.isRequired,
    tileWrap: string.isRequired
};
